module.exports = __webpack_public_path__ + "static/media/wechat-h5.4242013a.png";